module.exports = __webpack_public_path__ + "img/fullscreenExitOutlined.ee4907ba.png";